import React from 'react';
import OrganizationSearch from '../orgranization/organization-search';
import OrganizationTree from '../orgranization/organization-tree';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import VendorProgramModal from '../vendor-program/vendor-program-modal';
import cn from 'classnames';
import styles from '../../styles.module.scss';
import VendorProgramMultipleContainer from './vendor-program-multiple-container';
import OrganizationSelectedList from '../orgranization/organization-selected-list';
import VendorProgramListContainer from './vendor-program-list-container';

const VendorSolutionToolContainer = props => {
  const { hasBillingAccess } = props;

  const {
    selectedOrgNode,
    setSelectedOrgNode,
    selectedListOrg
  } = useVendorPointSolutionContext();

  return (
    <div id='vendor-point-solution-section' className={styles.vendorPointSection}>
      <h1>Vendor Point Solutions</h1>
      <a className={cn('button', styles.newVPBtn)} href='/vendor_point_management' target='_blank'>Add new vendor point solution</a>
      <OrganizationSearch />
      <OrganizationTree {...props} />

      {selectedOrgNode &&
        <VendorProgramModal
          onClose={() => setSelectedOrgNode(null)}
        >
          <VendorProgramListContainer {...props} />
        </VendorProgramModal>
      }
      {
        hasBillingAccess && selectedListOrg.length > 0 &&
        <React.Fragment>
          <OrganizationSelectedList />
          <VendorProgramMultipleContainer {...props}/>
        </React.Fragment>
      }
    </div>
  );
};

export default VendorSolutionToolContainer;
